import React from 'react';

import StaffList from './partials/stafflist';
import CreateStaff from './partials/CreateStaff';
import Deletestaff from './partials/DeleteStaff';
import Loading from '../common/Loading';

import staffExceptionList from './exception.json';
import './index.scss';

const login_types = [
  {value:'STAFF', label:'Business Staff'},
  {value:'MARKETING', label:'Marketing Staff'},
];

class Managestaff extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
      modalopen: false,
      showsucess: false,
      showfailure: false,
      deletesuccess: false,
      deletefailure: false,
      deleteLayover: false,
      staff: {},
      login_type:''
    };
    this.Managestafflist = [];
  }

  componentDidMount() {
    this.props.getStaffListMember();
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.staffManagement.adding === true &&
      nextProps.staffManagement.adding === false
    ) {
      if (nextProps.staffManagement.staffadded === true) {
        this.setState({
          showsucess: true,
        });
        setTimeout(() => {
          this.setState({
            showsucess: false,
          });
        }, 3000);
      } else {
        this.setState({
          showfailure: true,
        });
        setTimeout(() => {
          this.setState({
            showfailure: false,
          });
        }, 3000);
      }
    }
    if (
      this.props.staffManagement.deleteuser === true &&
      nextProps.staffManagement.deleteuser === false
    ) {
      if (nextProps.staffManagement.deletedstaff === true) {
        this.setState({
          deletesuccess: true,
        });
        setTimeout(() => {
          this.setState({
            deletesuccess: false,
          });
        }, 3000);
      } else {
        this.setState({
          deletefailure: true,
        });
        setTimeout(() => {
          this.setState({
            deletefailure: false,
          });
        }, 3000);
      }
    }
  }
  createStaff = (event) => {
    this.setState({
      modelopen: true,
      login_type:event.target.value || 'STAFF'
    });
  };
  closeCampaignModel = () => {
    this.props.clearFormFlags();
    this.setState({
      modelopen: false,
      login_type:''
    });
  };

  deleteStaff = (staff) => {
    const params = {
      client_id: staff.id,
    };
    this.props.deleteStaffMember(params);
    this.closeDeleteModel();
    console.log('remove', staff);
  };
  removeStaff = (staff) => {
    this.setState({
      deleteLayover: true,
      staff: staff,
    });
  };
  closeDeleteModel = () => {
    this.setState({
      deleteLayover: false,
      staff: {},
    });
  };
  canAddStaff = (list) => {
    const { auth } = this.props;
    const exception_list = ['85431'];
    const exception_list_for_large_practices = staffExceptionList;
    const isBrand = auth.brand_ids.includes(auth.studio_id) || exception_list.includes(auth.studio_id);
    let stafflsit = list.filter((user) => user.role == 'STAFF');
    if (auth.studio_id === '81453') {
      return stafflsit.length > 4;
    }
    if (exception_list_for_large_practices.includes(auth.studio_id)){
      return stafflsit.length > 9
    }
    return isBrand ? stafflsit.length > 14 : stafflsit.length > 2;
  };
  canAddManagementStaff = (list,limit) => {
    let stafflsit = list.filter((user) => user.role == 'MARKETING');
    console.log('stafflsit', stafflsit , limit);
    return stafflsit.length<limit;
  };
  render() {
    const {
      showsucess,
      modelopen,
      showfailure,
      deletesuccess,
      deletefailure,
      deleteLayover,
      staff,
      login_type
    } = this.state;
    const { staffManagement, auth, business, billing } = this.props;
    const { features } = auth;
    console.log('billing',staffManagement, billing.info?.plan?.marketing_staff_limit);
    return (
      <div className="managestaff">
        {staffManagement && staffManagement.loading ? (
          <div className="managestaff_loader">
            <Loading />
          </div>
        ) : (
          <div className="managestaff_title">
            <div className="managestaff_title_content">
              <div>Staff Accounts</div>
              {staffManagement && staffManagement.list && (
                <>
                {features && features.includes('MARKETING_STAFF_ENABLED') && this.canAddManagementStaff(staffManagement.list, billing.info?.plan?.marketing_staff_limit) ?
                (<div
                  className="install-button"
                >
                <select value={login_type} className="instruction-dropdown" onChange={this.createStaff}>
                  <option value='' disabled>+ Add staff account</option>
                  {login_types.map(type=>{
                    return <option value={type.value} disabled={type.value==='STAFF' && this.canAddStaff(staffManagement.list)} >{type.label}</option>
                  })}
                </select>
                </div>):
                (<div
                  className="install-button"
                  style={{
                    opacity:
                      this.canAddStaff(staffManagement.list)? 0.5 : 1,
                  }}
                >
                <button
                  className="instruction"
                  onClick={this.createStaff}
                  disabled={this.canAddStaff(staffManagement.list)}
                >
                  + Add staff account
                </button></div>)}
                </>
              )}
            </div>
            <div className="managestaff_title_description">
              <div>Business Staff Accounts grant your staff access to the Dashboard, Conversations, Help sections of your TrueLark account.<br/>
              {features && features.includes('MARKETING_STAFF_ENABLED') && <span>Marketing Staff Accounts grant your staff access to the Lead Engage and Outreach sections of your TrueLark account, where they can create and review performance of campaigns in your account.</span>}
              </div>
            </div>
            <div className="managestaff_title_list">
              <div className="stff-cust-list">
                <StaffList
                  staffs={staffManagement.list}
                  removeStaff={this.removeStaff}
                  staffManagement={staffManagement}
                  user={auth}
                />
              </div>
            </div>
            {(showsucess || deletesuccess) && (
              <div className="copy-webhook">
                <span className="tick-mark">
                  <i className="material-icons">check</i>
                </span>
                Staff account was {showsucess ? 'created' : 'Deleted'}.
              </div>
            )}
            {(showfailure || deletefailure) && (
              <div className="copy-webhook-failure">
                <span className="tick-mark">
                  <i className="material-icons">close</i>
                </span>
                {staffManagement.error}.
              </div>
            )}
          </div>
        )}
        {modelopen && (
          <CreateStaff
            modelopen={modelopen}
            closeCampaignModel={this.closeCampaignModel}
            staff={staffManagement}
            addStaffMember={this.props.addStaffMember}
            business={business}
            features={features}
            login_type={login_type}
          />
        )}
        {deleteLayover && (
          <Deletestaff
            staff={staff}
            modelopen={deleteLayover}
            closeDeleteModel={this.closeDeleteModel}
            deleteStaff={this.deleteStaff}
            staffManagement={staffManagement}
          />
        )}
      </div>
    );
  }
}
export default Managestaff;
